export default function KIYGIntro() {
  return (
    <div style={{ padding: "20px", textAlign: "left" }}>
      <h1 className="text-center">खेलो इंडिया यूथ गेम्स 2025 बिहार</h1>
      {/* <h3>About KIYG 2025</h3> */}
      <p>
        खेलो इंडिया भारत सरकार द्वारा शुरू किया गया एक प्रमुख कार्यक्रम है,
        जिसका उद्देश्य देश में खेल प्रतिभाओं की पहचान करना, जमीनी स्तर पर खेलों
        को बढ़ावा देना और खेल के बुनियादी ढांचे को विकसित करना है। यह पहल भारत
        में खेल संस्कृति को मजबूत करने की दिशा में एक महत्वपूर्ण कदम है।
      </p>
      <br />
      <p>
        पहली बार खेलो इंडिया यूथ गेम्स 2018 में दिल्ली में आयोजित किए गए थे।
        इसके बाद,
      </p>
      <br />
      <ul style={{ paddingLeft: "20px" }}>
        <li style={{ listStyleType: "disc" }}>2019 में पुणे, महाराष्ट्र,</li>
        <li style={{ listStyleType: "disc" }}>2020 में गुवाहाटी, असम,</li>
        <li style={{ listStyleType: "disc" }}>2022 में पंचकूला, हरियाणा,</li>
        <li style={{ listStyleType: "disc" }}>2023 में मध्य प्रदेश,</li>
        <li style={{ listStyleType: "disc" }}>2024 – तमिलनाडु</li>
      </ul>
      <br />
      <p>
        अब, खेलो इंडिया 2025 का आयोजन बिहार में होने जा रहा है। यह प्रतिष्ठित
        खेल प्रतियोगिता 4 मई से 15 मई 2025 तक चलेगी, जिसमें देशभर से युवा
        खिलाड़ी अपनी प्रतिभा का प्रदर्शन करेंगे। यह आयोजन बिहार में खेलों के
        प्रति जागरूकता बढ़ाने और खेल संस्कृति को नया आयाम देने में
        महत्वपूर्ण भूमिका निभाएगा।
      </p>
    </div>
  );
}
